var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Wizard",
    { staticClass: "tutorial-wizard", attrs: { logo: false } },
    [
      _c("a", {
        directives: [{ name: "close", rawName: "v-close" }],
        staticClass: "close",
        on: {
          click: function($event) {
            _vm.$close(false)
          }
        }
      }),
      _vm._v(" "),
      _c(
        _vm.steps[_vm.step - 1],
        { tag: "div", on: { proceed: _vm.proceed } },
        [
          _vm.steps && _vm.steps.length > 1
            ? [
                _c("PrevNext", {
                  staticClass: "nav",
                  attrs: {
                    step: _vm.step,
                    steps: _vm.steps,
                    pagevalid: _vm.pagevalid
                  }
                }),
                _vm._v(" "),
                _vm.step === _vm.steps.length
                  ? _c("button", {
                      staticClass: "arrow next",
                      on: { click: _vm.finish }
                    })
                  : _vm._e()
              ]
            : _vm._e()
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2a8b95be", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a8b95be","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/helpers/components/interact/Tutorial.vue
// module id = null
// module chunks = 